import { CSSProperties } from '@mui/material'
import { Link } from 'react-router-dom'

import TypeString from '#/components/FormatCell/Types/string'
import { useFarmSlug } from '#/store/ducks/farm'
import { PageId } from '#/store/services/Pages/PagesService'
import { getLink, GetLinkProps, getLinkTooltip } from '#/utils/getLink'

type Props = {
  value: string | number | null | undefined
  style?: CSSProperties
  linkTo: PageId
  blank?: boolean
  params?: Record<string, any>
  query?: Record<string, any>
  title?: string
  fallback?: GetLinkProps['fallback']
  additionalEnabled?: GetLinkProps['additionalEnabled']
}

const TypeLink = (props: Props) => {
  const { additionalEnabled, blank, fallback, linkTo, params, query, style, title, value } = props

  const farmSlug = useFarmSlug()

  let link = getLink({
    additionalEnabled,
    fallback,
    id: linkTo,
    params: { ...params, farm: params?.farm ?? farmSlug },
    query,
  })

  const tooltip = title ?? getLinkTooltip(linkTo)

  const target = blank ? '_blank' : undefined

  if (!value) {
    return '-'
  }

  if (value && link) {
    return (
      <Link to={link} style={style} target={target}>
        <TypeString value={value} tooltip={tooltip} bold />
      </Link>
    )
  }

  return <TypeString value={value} />
}
export { TypeLink }
